//Use this class for global constants

import { environment, SERVER_URL, IS_WEB } from "../environments/environment";

export class AppSettings {
  public static SERVER_URL = SERVER_URL;
  public static IS_WEB = IS_WEB;
}
